// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgInfoIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m1.433-14.584a1.415 1.415 0 1 0-2.833 0 1.415 1.415 0 1 0 2.833 0M10.6 12.248a1.415 1.415 0 1 1 2.83 0v4.17a1.415 1.415 0 1 1-2.83 0z"
    />
  </g>
);
export default SvgInfoIcon;
SvgInfoIcon.displayName = 'SvgInfoIcon';
